import React, {useState} from 'react';
// Animation
import {motion} from 'framer-motion';
import imageData from '../img/img-presta/imagesData'

import Gallery from '../components/Gallery';

const GalleryPage = () => {
    return(
        <div>
            <Gallery />
        </div>
    )
}

export default GalleryPage;